import React from 'react'
import { createContext, useContext, useState, ReactNode } from 'react'
import { Datum as Post } from '../../../services/interfaces/posts.interface/posts.getwall.interface'
import { Platform } from 'react-native'
let PostsServicesWeb: any = null
if (typeof Platform !== 'undefined' && Platform.OS === 'web') {
    try { PostsServicesWeb = require('../../../../database/posts.database').PostsServices } catch {}
}

export interface PostsContextValue {
    postsContext: Post[]
    setPostsContext: React.Dispatch<React.SetStateAction<Post[]>>
    getPostsByLabel: (pageNumber: number, pageSize: number, label_id: LabelIdT, array_posts?: Post[]) => Post[]
    dataPosts: Post[]
    setDataPosts: React.Dispatch<React.SetStateAction<Post[]>>
    updateViewPostsContext: (post_id: string, views: number) => void
    updateFavouritePostsContext: (post_id: string, status_favourite: 1 | 0) => void
    getPostsFavourite: (pageNumber: number, pageSize: number) => Post[]
    reloadFavourite: boolean
    form: any
    setForm: React.Dispatch<React.SetStateAction<any>>
    alreadySentForm?: boolean
    setAlreadySentForm?: React.Dispatch<React.SetStateAction<boolean>>
    commentsEnabled: boolean
    setCommentsEnabled: React.Dispatch<React.SetStateAction<boolean>>
}

interface PostContextProviderProps {
    children: ReactNode
}

export type LabelIdT =
    | '646794c8dcc130b7be06a883' // cursos
    | '6419c08b04ef61edd893bae9' // comercial
    | '641cbc10431e765226e299a6' // comunicacion
    | '64347879a75aeba2f7f71a89' // tecnico
    | '641cbc1a431e765226e299a7' // promociones
    | '6434788ca75aeba2f7f71a8b' // producto
    | -2 // todo
    | -1 // favourite

const PostContext = createContext<PostsContextValue | undefined>(undefined)

export const PostContextProvider = ({ children }: PostContextProviderProps) => {
    //set de tiendas
    const [postsContext, setPostsContext] = useState<Post[]>([])
    const [dataPosts, setDataPosts] = useState<Post[]>([])
    const [reloadFavourite, setReloadFavourite] = useState(false)

    /**
     * @description devuelvo todos los posteos que tengan el label que recibo por param
     * @param label_id
     * @returns {Post[]}
     */
    const getPostsByLabel = (pageNumber: number = 0, pageSize: number = 10, label_id: LabelIdT = null, array_posts?: Post[]) => {
        const offset = pageNumber * pageSize

        // console.log(`
        //             pageNumber: ${pageNumber},
        //             pageSize: ${pageSize},
        //             offset: ${offset},

        //         `)

        const posteos = array_posts && array_posts.length > 0 ? array_posts : postsContext

        const sortByPinnedThenDate = (a: Post, b: Post) => {
            const pinnedA = (a as any).isPinned ? 1 : 0
            const pinnedB = (b as any).isPinned ? 1 : 0
            if (pinnedB !== pinnedA) return pinnedB - pinnedA
            return Number(new Date((b as any).publication_date)) - Number(new Date((a as any).publication_date))
        }

        if (label_id === -2 || !label_id) {
            return [...posteos].sort(sortByPinnedThenDate).slice(offset, offset + pageSize)
        }

        const newPosts = posteos
            .filter((post) => {
                if (post.labels && post.labels.length > 0) {
                    return post.labels.some((label) => label._id === label_id)
                } else {
                    return false
                }
            })
            .sort(sortByPinnedThenDate)

        return newPosts.slice(offset, offset + pageSize)
    }

    const updateViewPostsContext = (post_id: string, views: number) => {
        setPostsContext((prev) => {
            return prev.map((post) => {
                if (post._id === post_id) {
                    return {
                        ...post,
                        views: views,
                    }
                }
                return post
            })
        })

        setDataPosts((prev) => {
            return prev.map((post) => {
                if (post._id === post_id) {
                    return {
                        ...post,
                        views: views,
                    }
                }
                return post
            })
        })
    }

    const updateFavouritePostsContext = (post_id: string, status_favourite: 1 | 0) => {
        // console.log("80 -------- 🚀 ~ file: posts.context.tsx:80 ~ updateFavouritePostsContext ~ status_favourite:", status_favourite)
        setPostsContext((prev) => {
            return prev.map((post) => {
                if (post._id === post_id) {
                    return {
                        ...post,
                        status_favourite: status_favourite,
                    }
                }
                return post
            })
        })

        // Persistencia web en memoria/localStorage (stub)
        if (Platform.OS === 'web' && PostsServicesWeb) {
            try {
                const target = PostsServicesWeb?.getAllPosts ? PostsServicesWeb : null
                // Actualizamos el estado interno de memoryState modificando el array original (optimización simple)
                if (target) {
                    // Recuperar lista y mutar el que corresponda (stub ya persiste en addAllPosts si reasignamos)
                    target.getAllPosts(0, -1).then((all) => {
                        const updated = all.map((p) => p._id === post_id ? { ...p, status_favourite } : p)
                        target.addAllPosts(updated)
                    })
                }
            } catch {}
        }

        setReloadFavourite(!reloadFavourite)
    }

    const getPostsFavourite = (pageNumber: number = 0, pageSize: number = 10) => {
        const source = postsContext.filter((post) => post.status_favourite === 1)
            .sort((a, b) => Number(new Date(b.publication_date)) - Number(new Date(a.publication_date)))
        const offset = pageNumber * pageSize
        const slice = source.slice(offset, offset + pageSize)
        setDataPosts(slice)
        return slice
    }
    const [form, setForm] = useState(null)
    const [alreadySentForm, setAlreadySentForm] = useState<boolean>(false)
    const [commentsEnabled, setCommentsEnabled] = useState<boolean>(true)
    const value: PostsContextValue = {
        postsContext,
        setPostsContext,
        getPostsByLabel,
        dataPosts,
        setDataPosts,
        updateViewPostsContext,
        updateFavouritePostsContext,
        getPostsFavourite,
        reloadFavourite,
        form,
        setForm,
        alreadySentForm,
        setAlreadySentForm,
        commentsEnabled,
        setCommentsEnabled,
    }

    return <PostContext.Provider value={value}>{children}</PostContext.Provider>
}

export const usePostContext = (): PostsContextValue => {
    const context = useContext(PostContext)
    if (!context) {
        throw new Error('usePostContext must be used within a PostContextProvider')
    }
    return context
}
